import { ECountryCode } from "../index.dto";

export const getIdentificationDocumentSub = (
  countryCode: ECountryCode
): {
  AS: string;
  BILL: string;
} => {
  if (countryCode === ECountryCode.ID) {
    return {
      AS: "KTP, KITAS, KITAP or Passport",
      BILL: "KTP / Passport",
    };
  }

  return {
    AS: "Government ID / Passport",
    BILL: "Government ID / Passport",
  };
};

export enum ETypeOfPIC {
  AS = "authorizedSignatory",
  BILL = "billingPIC",
}

export enum ETypeOfDoc {
  POA = "poaDoc",
  ID = "idDoc",
  DIR_ID = "dirIdDoc",
}

export enum ERequirementDocs {
  ID = "https://storage.googleapis.com/frontend-ui-assets/golive/requirement-docs/SURAT%20KUASA_POWER%20OF%20ATTORNEY.docx",
  PH = "https://storage.googleapis.com/frontend-ui-assets/golive/requirement-docs/Sec%20Cert%20-%20general%20matters.docx",
}
